var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrollArrow = function SvgScrollArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#scroll-arrow_svg__a)",
    d: "M21.308 4.392a.554.554 0 0 0 .058-.672 13.6 13.6 0 0 0-1.164-1.503q-.486-.557-1.039-1.054-.562-.514-1.18-.954a.466.466 0 0 0-.618.07L11.68 6.352a1.18 1.18 0 0 1-1.74 0L4.14.156A.47.47 0 0 0 3.527.08q-.627.436-1.2.946-.724.632-1.356 1.376-.47.545-.879 1.14a.55.55 0 0 0 .052.679l3.72 3.976 2.176 2.325c2.631 2.807 6.908 2.807 9.54 0l5.73-6.121z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scroll-arrow_svg__a",
    x1: 10.726,
    x2: 10.726,
    y1: 0,
    y2: 12.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgba(3, 31, 71, 0.74)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#1B509C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3484F7"
  })))));
};
export default SvgScrollArrow;